import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ProjectItem } from "../../components/Chatbot/types/project";

export interface ChatDrawerState {
    isOpen: boolean;
    isWebAllowed: boolean;
    queryMetaData: Record<string, any> | null;
    agentData?: ProjectItem[];
    initialProjectId?: string; // Initial project ID to set when drawer opens with agentData
}

const initialState: ChatDrawerState = {
    isOpen: false,
    isWebAllowed: true,
    queryMetaData: null,
    agentData: undefined,
    initialProjectId: undefined,
};

const slice = createSlice({
    name: "chatDrawer",
    initialState,
    reducers: {
        setDrawerState: (state: ChatDrawerState, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setIsWebAllowed: (state: ChatDrawerState, action: PayloadAction<boolean>) => {
            state.isWebAllowed = action.payload;
        },
        setQueryMetaData: (state: ChatDrawerState, action: PayloadAction<Record<string, any> | null>) => {
            state.queryMetaData = action.payload;
        },
        toggleDrawer: (state: ChatDrawerState) => {
            state.isOpen = !state.isOpen;
        },
        setAgentData: (state: ChatDrawerState, action: PayloadAction<ProjectItem[] | undefined>) => {
            state.agentData = action.payload;
        },
        setInitialProjectId: (state: ChatDrawerState, action: PayloadAction<string | undefined>) => {
            state.initialProjectId = action.payload;
        },
    },
});

export const { setDrawerState, setIsWebAllowed, setQueryMetaData, toggleDrawer, setAgentData, setInitialProjectId } = slice.actions;
export const chatDrawerReducer = slice.reducer;
export default chatDrawerReducer;